import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Image, Typography, Spin, Tag, Carousel, Input, Select } from 'antd';
import axios from 'axios';
import { YealinkDevices } from './data/QuoteListing';

const { Title, Text } = Typography;
const { Search } = Input;
const { Option } = Select;

const ProductListing: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState<any[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [selectedFeature, setSelectedFeature] = useState<string | null>(null);

  useEffect(() => {
    // Fetch product data from API
    const fetchData = async () => {
      try {
        setProducts(YealinkDevices);
        setFilteredProducts(YealinkDevices);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching product data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Filter products based on search query and selected feature
    let filtered = products.filter(product => {
        const productName = product.ProductName || '';
        const features = product.Features || [];
        const environmentalFeatures = product.EnvironmentalFeatures || [];
        const otherFeatures = product.OtherFeatures || [];
        const categories = product.Categories || [];
    
        return (
          productName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          features.some((feature: any) => feature.Value?.toLowerCase().includes(searchQuery.toLowerCase())) ||
          environmentalFeatures.some((feature: any) => feature.Value?.toLowerCase().includes(searchQuery.toLowerCase())) ||
          otherFeatures.some((feature: any) => feature.Value?.toLowerCase().includes(searchQuery.toLowerCase())) ||
          categories.some((category: any) => category.Name?.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      });
    
      if (selectedFeature) {
        filtered = filtered.filter(product => {
          const features = product.Features || [];
          const environmentalFeatures = product.EnvironmentalFeatures || [];
          const otherFeatures = product.OtherFeatures || [];
          const categories = product.Categories || [];
    
          return (
            features.some((feature: any) => feature.Name === selectedFeature) ||
            environmentalFeatures.some((feature: any) => feature.Name === selectedFeature) ||
            otherFeatures.some((feature: any) => feature.Name === selectedFeature) ||
            categories.some((category: any) => category.Name === selectedFeature)
          );
        });
      }
    
      setFilteredProducts(filtered);
      }, [searchQuery, selectedFeature, products]);

  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };

  const handleSelectChange = (value: string) => {
    setSelectedFeature(value || null);
  };

  if (loading) {
    return <Spin size="large" />;
  }

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Search placeholder="Search products" onSearch={handleSearch} enterButton />
        </Col>
        <Col span={12}>
          <Select placeholder="Filter by feature" onChange={handleSelectChange}>
            {[
              ...new Set(
                products.flatMap(product => [
                  ...product.Features.map((feature: { Name: any; }) => feature.Name),
                  ...product.EnvironmentalFeatures.map((feature: { Name: any; }) => feature.Name),
                  ...product.OtherFeatures.map((feature: { Name: any; }) => feature.Name),
                  ...product.Categories.flatMap((category: { Name: any; SubCategories: any[]; }) => [category.Name, ...category.SubCategories.map((sub: { Name: any; }) => sub.Name)])
                ])
              )
            ].map((feature, index) => (
              <Option key={index} value={feature}>
                {feature}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        {filteredProducts.map((product) => (
          <Col key={product.SKU} xs={24} sm={12} md={8} lg={6}>
            <Card
              hoverable
              title={product.ProductName}
            //   extra={<Text strong>${product.UnitPrice}</Text>}
            >
              <Carousel>
                {product.Images.map((image: { Description: any; ResourceUrl: string | undefined; }, index: React.Key | null | undefined) => (
                  <div key={index}>
                    <Image
                      alt={image.Description || product.ProductName}
                      src={image.ResourceUrl}
                      preview={{
                        mask: <Image src={image.ResourceUrl} />,
                      }}
                      style={{ width: '100%', maxHeight: '300px', objectFit: 'contain' }}
                    />
                  </div>
                ))}
              </Carousel>
              <Tag color="green">{`$${product.UnitPrice}`}</Tag>
              <Tag>{`Quantity: ${product.Quantity}`}</Tag>
              <div dangerouslySetInnerHTML={{ __html: product.ProductDescription }} />
              {/* {product.SpecialOrder && <Tag color="gold">Special Order</Tag>} */}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ProductListing;
